import loading from './loading2'

export default loading
